module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAAIhJREFUOI2tktsRQEAMRY9HYVEZOtEJOtEJH9ZOrDH2Il/JzsnNnWThhyhc3r7o7wGqUBgwhHzJFOiAOeUNGAUXt/wqiES+dA/qTiLvF3tYmzJFLLD9l+vMwsDnKJL61V9JF2tC84U1tPOeeO9kEkROvBcxUSTytVPt2C0qjkagSa+jujkMfI8Np0YabH7ods8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliFangshi.png
// module id = pcqx
// module chunks = 1